module.exports = __webpack_public_path__ + "img/5running4.fdd68eb5.jpg";